import { ProgramType } from "shared/enums/ProgramType";
import { ApiProgramResponse } from "shared/types/ApiProgramResponse";
import BuyersProgram from "./buyersProgram";
import EmptyProgram from "./emptyProgram";
import InPersonMeetupProgram from "./inPersonMeetupProgram";
import MeetupProgram from "./meetupProgram";
import TabletalkProgram from "./tabletalkProgram";
import AssociatedProgram from "./associatedProgram";
import TradeProgram from "./tradeProgram";
import ConnectionsProgram from "./connectionsProgram";

export default function ProgramFactory(programDetails?: ApiProgramResponse) {
  if (!programDetails) {
    return new EmptyProgram(null);
  }

  switch (programDetails.programType) {
    case ProgramType.BUYERS_PROGRAM:
      return new BuyersProgram(programDetails);
    case ProgramType.MEETUP_PROGRAM:
      return new MeetupProgram(programDetails);
    case ProgramType.IN_PERSON_MEETUP_PROGRAM:
      return new InPersonMeetupProgram(programDetails);
    case ProgramType.TRADE_PROGRAM:
      return new TradeProgram(programDetails);
    case ProgramType.TABLETALK_PROGRAM:
      return new TabletalkProgram(programDetails);
    case ProgramType.ASSOCIATED_PROGRAM:
      return new AssociatedProgram(programDetails);
    case ProgramType.CONNECTIONS_PROGRAM:
      return new ConnectionsProgram(programDetails);
    default:
      throw new Error("Invalid program type");
  }
}
